module.exports = __webpack_public_path__ + "static/media/WHO-FR-C-H.e509206a.png";